import { FunctionComponent } from 'react';
import { AdTargeting } from 'types/Slideshow';
import Ad from 'components/Ad';
import { screen } from 'components/styles/variables';
import { MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import { omitUndefined } from 'lib/utils';

interface SlideshowDesktopAdProps {
  adTargeting?: AdTargeting;
}

const SlideshowDesktopAd: FunctionComponent<SlideshowDesktopAdProps> = ({
  adTargeting,
}: SlideshowDesktopAdProps) => {
  const adTargetingFields = {
    make: adTargeting?.make,
    model: adTargeting?.model,
    year: adTargeting?.year,
    body_style: adTargeting?.type,
  };

  return (
    <div className="desktop-slideshow-sidebar-ads">
      <div>
        <Ad
          adConfig={{
            targeting: omitUndefined({
              inLine: 2,
              ...adTargetingFields,
            }),
            dimensions: [
              [300, 250],
              [300, 600],
            ],
          }}
          placeholderSize={MEDIUM_RECTANGLE}
          className={'desktop-slideshow-ad'}
        />
        <Ad
          adConfig={{
            targeting: omitUndefined({
              inLine: 3,
              ...adTargetingFields,
            }),
            dimensions: [[300, 250]],
          }}
          placeholderSize={MEDIUM_RECTANGLE}
          className={'desktop-slideshow-ad'}
        />
      </div>
      <style jsx>{`
        .desktop-slideshow-sidebar-ads {
          display: none;
        }

        @media (min-width: ${screen.lgMin}) {
          .desktop-slideshow-sidebar-ads {
            display: flex;
            margin-left: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default SlideshowDesktopAd;
